// @hooks
import Loading from "components/loading"
import usePrismicBySingle from "hooks/usePrismicBySingle"

// @styles
import './styles.scss'

export default function Footer() {
    const { info, loading } = usePrismicBySingle('footer')

    if (loading) {
        return (
            <Loading />
        )
    }

    return (
        <footer className={`footer-ppal ${document.getElementsByClassName('sidebar-resume').length > 0 && 'sidebar-space'}`}>
            <div className='container-xl'>
                <div className='footer-ppal__container'>
                    <img src={info.logo.url} alt={info.logo.alt} className='footer-ppal__logo' />
                    <div className='footer-ppal__kick-links'>
                        {info.kick_links &&
                            info.kick_links.map((item, index) => {
                                if (item.link.link_type === 'Web') {
                                    const indexOf = item.link.url.indexOf("tel");
                                    return (
                                        <a
                                            href={item.link.url}
                                            target={indexOf === -1 ? '_blank' : null}
                                            rel='noopenner'
                                            key={`link-${index}`}
                                        >
                                            <span>{item.title[0]?.text}</span>
                                            <strong>{item.description[0]?.text}</strong>
                                        </a>
                                    )
                                }
                                if (item.link.link_type === 'Any') {
                                    return (
                                        <div
                                            key={`item-${index}`}
                                        >
                                            <span>{item.title[0]?.text}</span>
                                            <strong>{item.description[0]?.text}</strong>
                                        </div>
                                    )
                                }
                            })
                        }
                    </div>
                </div>

                <div className='footer-ppal__container'>
                    <div className='footer-ppal__copy'>
                        {info.copy[0]?.text}
                    </div>
                    <div className='footer-ppal__social'>
                        {info.social.map((item, index) =>
                            item.link.link_type !== 'Any' &&
                            <a
                                href={item.link.url}
                                key={`social-${index}`}
                                target='_blank'
                                rel='nooppener'
                            >
                                <em className={`fab fa-${item.icon}`} />
                            </a>
                        )}
                    </div>
                </div>
            </div>
        </footer>
    )
}